"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find-index");
var _toConsumableArray2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es6.number.constructor");
var _vueImageCropUpload = _interopRequireDefault(require("vue-image-crop-upload"));
var _vueEleGallery = _interopRequireDefault(require("vue-ele-gallery"));
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'EleUploadImage',
  components: {
    Cropper: _vueImageCropUpload.default,
    EleGallery: _vueEleGallery.default
  },
  props: {
    // 值
    value: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    // 是否剪裁
    crop: {
      type: Boolean,
      default: false
    },
    // 图片显示大小
    size: {
      type: Number,
      default: 150
    },
    // 裁剪高度
    cropHeight: {
      type: Number,
      default: 150
    },
    // 裁剪宽度
    cropWidth: {
      type: Number,
      default: 150
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 2
    },
    // 响应处理函数
    onSuccess: {
      type: Function,
      default: null
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: function _default() {
        return ['png', 'jpg', 'jpeg', 'gif'];
      }
    },
    // 缩略图后缀, 例如七牛云缩略图样式 (?imageView2/1/w/20/h/20)
    thumbSuffix: {
      type: String,
      default: ''
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    // 弹窗标题
    title: {
      type: String,
      default: ''
    },
    // 图片懒加载
    lazy: {
      type: Boolean,
      default: false
    },
    // 上传地址 (同官网)
    action: {
      type: String,
      required: true
    },
    // 文件个数显示(同官网)
    limit: {
      type: Number,
      default: 1
    },
    // 是否启用拖拽上传 (同官网)
    drag: {
      type: Boolean,
      default: false
    },
    // 	支持发送 cookie 凭证信息 (同官网)
    withCredentials: {
      type: Boolean,
      default: false
    },
    // 是否支持多选文件 (同官网)
    multiple: {
      type: Boolean,
      default: false
    },
    // 上传时附带的额外参数(同官网)
    data: {
      type: Object,
      default: null
    },
    // 上传的文件字段名 (同官网)
    name: {
      type: String,
      default: 'file'
    },
    // 接受上传的文件类型（thumbnail-mode 模式下此参数无效）(同官网)
    accept: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      cropData: {},
      isShowCrop: false,
      uploading: false,
      fileList: []
    };
  },
  computed: {
    // 是否显示提示
    showTip: function showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
    computedValues: function computedValues() {
      if (this.value) {
        if (typeof this.value === 'string') {
          return [this.value];
        } else {
          return (0, _toConsumableArray2.default)(this.value);
        }
      } else {
        return [];
      }
    },
    isShowUpload: function isShowUpload() {
      if (this.multiple) {
        return true;
      } else {
        return this.computedValues.length === 0;
      }
    },
    successFiles: function successFiles() {
      return this.fileList.filter(function (file) {
        return file.status === 'success';
      });
    }
  },
  watch: {
    isShowCrop: function isShowCrop(value) {
      if (value === false) {
        this.cropData = {};
      }
    }
  },
  mounted: function mounted() {
    // 插入到body中, 避免弹出层被遮盖
    if (this.crop && this.$refs.cropper) {
      document.body.appendChild(this.$refs.cropper.$el);
    }
  },
  methods: {
    handleSetFileSet: function handleSetFileSet(fileName, fileType, fileSize) {
      var uid = this.cropData.uid || new Date().getTime();
      this.cropData = {
        name: fileName,
        percentage: 0,
        size: fileSize,
        type: fileType,
        status: 'ready',
        uid: uid
      };
    },
    handleCropSuccess: function handleCropSuccess(b64Data) {
      this.cropData.url = b64Data;
    },
    handleCropUploadError: function handleCropUploadError(status) {
      this.$message.error('上传失败, 请重试');
      this.$emit('error', status);
    },
    handleCropUploadSuccess: function handleCropUploadSuccess(res) {
      if (res.code === 0) {
        this.cropData.status = 'success';
        this.cropData.percentage = 100;
        this.cropData.response = res;
        var file = Object.assign({
          'uid': 1
        }, this.cropData);
        var index = this.fileList.findIndex(function (item) {
          return item.uid === file.uid;
        });
        if (index > -1) {
          this.fileList.splice(index, 1, file);
        } else {
          this.fileList.push(file);
        }
        this.handleUploadSuccess(res, file, this.fileList);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 上传前校检格式和大小
    handleBeforeUpload: function handleBeforeUpload(file) {
      var isImg = false;
      if (this.fileType) {
        var fileExtension = '';
        if (file.name.lastIndexOf('.') > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
        }
        isImg = this.fileType.some(function (type) {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf('image') > -1;
      }
      if (!isImg) {
        this.$message.error("\u6587\u4EF6\u683C\u5F0F\u4E0D\u6B63\u786E, \u8BF7\u4E0A\u4F20".concat((this.fileType || []).join('/'), "\u56FE\u7247\u683C\u5F0F\u6587\u4EF6!"));
        return false;
      }
      if (this.fileSize) {
        var isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error("\u4E0A\u4F20\u5934\u50CF\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ".concat(this.fileSize, " MB!"));
          return false;
        }
      }
      this.uploading = true;
      return true;
    },
    handleChange: function handleChange(file, fileList) {
      this.uploading = false;
      this.fileList = fileList;
    },
    // 文件个数超出
    handleExceed: function handleExceed() {
      this.$message.error("\u6700\u591A\u4E0A\u4F20".concat(this.limit, "\u5F20\u56FE\u7247"));
    },
    // 上传失败
    handleUploadError: function handleUploadError(err) {
      this.uploading = false;
      this.$message.error('上传失败, 请重试');
      this.$emit('error', err);
    },
    // 上传成功回调
    handleUploadSuccess: function handleUploadSuccess(response, file) {
      var url = response.data.url;
      this.uploading = false;
      this.$message.success('上传成功');
      if (this.onSuccess) {
        this.onSuccess(response, file, this.successFiles);
      }
      if (this.multiple) {
        if (Array.isArray(this.value)) {
          this.$emit('input', [].concat((0, _toConsumableArray2.default)(this.value), [url]));
        } else {
          this.$emit('input', [url]);
        }
      } else {
        this.$emit('input', url);
      }
    },
    handleRemove: function handleRemove(index) {
      if (this.multiple) {
        var data = (0, _toConsumableArray2.default)(this.computedValues);
        data.splice(index, 1);
        this.$emit('input', data || []);
      } else {
        this.$emit('input', null);
      }
    }
  }
};
exports.default = _default2;